import { InputLabel, Stack, Switch } from "@mui/material";
import { isEmpty } from "lodash-es";
import type { FC } from "react";
import { useElementTracking } from "../../../../analytics/analytics";

export const TableColumnPopoverToggle: FC<{
  label: string;
  name: string;
  onChange: (checked: boolean) => void;
  value: boolean;
}> = ({ label, name, onChange, value }) => {
  const analyticsProps = useElementTracking("email_design", name, "toggle");
  return (
    <Stack direction={"row"} alignItems={"center"}>
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Switch
        data-analytics-id="lexical-table-menu-cell-individual-padding"
        checked={value === true || !isEmpty(value)}
        onChange={(_, checked) => onChange(checked)}
        slotProps={{ input: { "aria-labelledby": `${name}-label`, ...analyticsProps } }}
      />
    </Stack>
  );
};
